import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import {
  formatDateTimeStamp,
  isLargeScreen,
  updateCustomTableHeaders,
} from '../../../../../global.variable';
import { LoadingSpinnerService } from '../../../../shared/services/loading-spinner.service';
import { HolAndMessageService } from '../hol-and-message.service';
import { ModalDialogueService } from '../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { ConfirmDialogComponent } from '../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { firstValueFrom } from 'rxjs';
import { ToasterService } from '../../../../shared/services/toaster.service';

@Component({
  selector: 'gtapp-pinned-message',
  standalone: false,
  templateUrl: './pinned-message.component.html',
  styleUrl: './pinned-message.component.scss',
})
export class PinnedMessageComponent implements OnInit, OnDestroy {
  @Input() shownFrom: string = 'hol';
  @Output() emitData = new EventEmitter();
  largeView = isLargeScreen;
  previousPinnedMessages: number = 0;
  rowsPinnedMessages: number = 10;
  pageNumPinnedMessages: number = 1;
  totalPinnedMessageCount: number = 0;

  sortKeyPinnedMessages: any = 'pin_till';
  searchParamsPinnedMessages: any;

  pinnedMessageSearchString: string = '';
  pinnedMessageDropDownList: any = [];

  pinnedMessagePaginationData: any = {};

  selectedPinnedMessage: any = {};

  addNewMessage: boolean = false;

  otherParamsPinnedMessages: any = {
    apiFiltering: true,
    hideHeaders: true,
  };

  pinnedMessageDetailsTableView: any = [];
  tableStyle = { 'overflow': 'auto', 'max-height': 'calc(100vh - 255px)' };

  constructor(
    private route: ActivatedRoute,
    private pinnedMessageService: HolAndMessageService,
    private router: Router,
    private spinnerService: LoadingSpinnerService,
    private dialogService: ModalDialogueService,
    private toasterService: ToasterService,
  ) {
    this.formatRouteUrl();
    this.getTableDetails();
  }
  ngOnDestroy() {}
  ngOnInit() {
    this.rowsPinnedMessages =
      this.shownFrom == 'home' ? 4 : this.rowsPinnedMessages;

    this.getPinnedMessageListData(true);
  }

  onPinnedMessageLookup(event: any) {
    if (event.target.value.length > 3) {
      this.pinnedMessageService
        .getPinnedMessages({ search_str: event?.target.value })
        .subscribe((response: any) => {
          if (response['status'] == 'success') {
            this.pinnedMessageDropDownList = response?.data;
          }
        });
    }
  }
  getPinnedMessagesCount(reqParams: any) {
    let params: any = { get_count: 1, ...reqParams };

    this.pinnedMessageService
      .getPinnedMessages(params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.otherParamsPinnedMessages = {
            ...this.otherParamsPinnedMessages,
            paginationData: {
              totalRows: response?.total_size,
              previousRows: this.previousPinnedMessages,
              rows: this.rowsPinnedMessages,
              pageNum: this.pageNumPinnedMessages,
            },
          };

          this.totalPinnedMessageCount =
            response?.total_pinnedMessage_count || 0;
        }
      });
  }
  getPinnedMessageListData(getCount = true) {
    let params: any = {};
    if (this.rowsPinnedMessages) {
      params['page_size'] = this.rowsPinnedMessages;
    }

    if (this.previousPinnedMessages) {
      params['previous'] = this.previousPinnedMessages;
    }
    if (this.pinnedMessageSearchString) {
      params['search_str'] = this.pinnedMessageSearchString;
    }
    if (this.shownFrom == 'home') params.active_only = 1;

    if (this.searchParamsPinnedMessages) {
      Object.entries(this.searchParamsPinnedMessages).forEach(
        ([key, value]) => (params[key] = value),
      );
    }

    if (this.sortKeyPinnedMessages) {
      params['sort_key'] = this.sortKeyPinnedMessages;
    }

    if (this.pinnedMessagePaginationData?.[this.pageNumPinnedMessages]?.length)
      return;
    if (getCount && this.shownFrom !== 'home')
      this.getPinnedMessagesCount(params);

    this.spinnerService.show();
    this.pinnedMessageService
      .getPinnedMessages(params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.pinnedMessagePaginationData[this.pageNumPinnedMessages] = [
            ...response?.data,
          ];
          if (this.shownFrom == 'home') {
            this.emitData.emit(!!response?.data?.length);
          } else {
            this.updateRoutPath();
          }
          this.spinnerService.hide();
        } else {
          this.spinnerService.hide();
        }
      });
  }
  updateRoutPath() {
    this.router.navigate([], {
      fragment: btoa(
        JSON.stringify({
          searchParams: this.searchParamsPinnedMessages,
          otherParams: this.otherParamsPinnedMessages,
          pinnedMessageSearchString: this.pinnedMessageSearchString,
          selectedTab: 'Pinned Messages',
        }),
      ),
      queryParams: {},
      replaceUrl: true,
    });
  }
  routeToPinnedMessages() {
    this.router.navigate(['/hand-over-log'], {
      fragment: btoa(
        JSON.stringify({
          selectedTab: 'Pinned Messages',
        }),
      ),
      queryParams: {},
    });
  }

  rowClick(event: any) {
    if (this.shownFrom == 'home') {
      this.routeToPinnedMessages();

      return;
    }
    this.addNewMessage = false;
    if (this.largeView) {
      this.selectedPinnedMessage = event;
    } else {
      this.router.navigate(['/add-edit-pinned-message'], {
        queryParams: { pMId: btoa(event?.id) },
      });
    }
  }
  async onActionClick(event: any) {
    const eventData = event?.event;
    if (event?.type == 'detail') {
      this.rowClick(eventData);
    }
    if (event?.type == 'archive') {
      const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
        data: {
          title: 'Are you sure?',
          message: 'THIS ACTION CANNOT BE UNDONE!',
          btn2Detail: { text: 'Delete', class: 'btn-danger' },
        },
      });
      const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
      if (dialogResponse == true) {
        this.spinnerService.show('Removing Message');
        this.pinnedMessageService
          .updatePinnedMessage(btoa(eventData?.id), {}, { delete_message: 1 })
          .then((response: any) => {
            if (response?.status != 'success') {
              this.toasterService.setMessage({
                errorMessage: response?.message,
                successMessage: '',
              });
              return;
            }
            if (eventData?.id == this.selectedPinnedMessage?.id)
              this.selectedPinnedMessage = {};
            // this.addNewMessage = false;
            this.clearValues();
            this.getPinnedMessageListData();
          });
      }
    }
  }
  openAddNewPinnedMessageDialog() {
    this.selectedPinnedMessage = {};
    if (this.largeView) {
      this.addNewMessage = true;
    } else {
      this.router.navigate(['/add-edit-pinned-message']);
    }
    document.querySelector('tr.selected')?.classList.remove('selected');
  }
  onChangePaginationPinnedMessage(data: any) {
    this.previousPinnedMessages = data?.paginationData?.previousRows;
    this.pageNumPinnedMessages = data?.paginationData?.pageNum;
    if (data?.paginationData?.rows != this.rowsPinnedMessages) {
      this.pinnedMessagePaginationData = {};
    }
    this.rowsPinnedMessages = data?.paginationData?.rows;

    this.otherParamsPinnedMessages.paginationData = {
      ...data?.paginationData,
    };
    this.getPinnedMessageListData(false);
  }
  sortColumnPinnedMessage(body: any) {
    this.sortKeyPinnedMessages = body?.sortList || [];
    this.searchParamsPinnedMessages = body?.searchParams || {};
    this.pinnedMessageSearchString = '';
    this.pinnedMessagePaginationData = {};
    this.getPinnedMessageListData(false);
  }
  searchColumnPinnedMessage(event: any) {
    this.searchParamsPinnedMessages = event?.searchParams || {};
    this.clearValues();
    this.getPinnedMessageListData();
  }
  clearValues() {
    this.previousPinnedMessages = 0;
    this.pageNumPinnedMessages = 1;
    this.pinnedMessageSearchString = '';
    this.pinnedMessagePaginationData = {};
  }
  formatRouteUrl() {
    if (!this.route.snapshot.fragment) return;
    try {
      const urlFragmentDetails = JSON.parse(atob(this.route.snapshot.fragment));
      if (urlFragmentDetails && Object.keys(urlFragmentDetails)?.length) {
        this.searchParamsPinnedMessages = {
          ...this.searchParamsPinnedMessages,
          ...(urlFragmentDetails?.searchParams || {}),
        };

        this.pinnedMessageSearchString =
          urlFragmentDetails?.pinnedMessageSearchString || '';

        if (urlFragmentDetails?.otherParams?.paginationData) {
          this.previousPinnedMessages =
            urlFragmentDetails?.otherParams?.paginationData?.previousRows ||
            this.previousPinnedMessages;
          this.pageNumPinnedMessages =
            urlFragmentDetails?.otherParams?.paginationData?.pageNum ||
            this.pageNumPinnedMessages;
          this.rowsPinnedMessages =
            urlFragmentDetails?.otherParams?.paginationData?.rows ||
            this.rowsPinnedMessages;
        }
      }
    } catch (error) {}
  }
  getTableDetails() {
    let tableDetails = [
      {
        prefixNestedValue: (row: any) => {
          return row?.pin_till
            ? `Shown Until: ${formatDateTimeStamp(row?.pin_till, 'd MMMM y', 'en_US')}\n\n `
            : null;
        },

        prefixStyle: {
          'font-size': '0.8rem',
          'color': 'red',
        },

        nestedValue: (row: any) => {
          return row?.message?.length > 150
            ? `${row?.message?.slice(0, 150)}...`
            : row?.message;
        },

        columnDataStyle: {
          'white-space': 'pre-line',
          // 'font-size': 'small',
        },

        tableColumnStyle: {
          'white-space': 'pre-line',
          'background': '#ffff88',
          'color': '#212529',
          'border-radius': '0',
          'border': '1px solid black',
          'border-right': '0',
        },
      },
      {
        header: '',
        showAction: true,
        actionOptions: [
          {
            condition: function (row: any) {
              return {
                icon: 'fa-solid fa-thumbtack fs-5 mb-4',
                type: 'detail',
              };
            },
          },
          {
            role: 'button',

            condition: function (row: any) {
              return {
                icon: 'fa-solid fa-circle-minus text-danger fs-5',
                type: 'archive',
              };
            },
          },
        ],
        tableColumnStyle: {
          'background': '#ffff88',
          'color': '#212529',
          'border-radius': '0',
          'border': '1px solid black',
          'border-left': '0',
          'vertical-align': 'top',
        },
      },
    ];

    updateCustomTableHeaders(tableDetails, this.searchParamsPinnedMessages);

    this.pinnedMessageDetailsTableView = [...tableDetails];
  }
  onMessageUpdated(event: any) {
    switch (event?.action) {
      case 'cancel':
        this.selectedPinnedMessage = {};
        this.addNewMessage = false;
        break;

      case 'saved':
        this.selectedPinnedMessage = {};
        this.addNewMessage = false;
        this.clearValues();
        this.getPinnedMessageListData();
        break;
      case 'delete':
        this.selectedPinnedMessage = {};
        this.addNewMessage = false;
        this.clearValues();
        this.getPinnedMessageListData();
        break;
      case 'updated':
        this.addNewMessage = false;
        this.clearValues();
        this.getPinnedMessageListData();
        break;
    }
  }
}
